<template>
    <section id='interview-data'>
        <b-container fluid>
            <b-card title='Опросник'>
                <b-form>
                    <b-form-group 
                        id='radio-group-had-covid'
                        label="Болел COVID-19"
                        label-for="select-had-covid"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="select-had-covid"
                            v-model="interview.hadCovid"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-had-covid"
                            required
                        ></b-form-radio-group>
                    </b-form-group>
                    
                    <b-form-group 
                        v-if="interview.hadCovid === 3"
                        label="Дата окончания болезни:"
                        label-for="datepicker-ending-covid"
                        label-cols-sm="3"
                        label-cols-lg="3"
                    >
                        <datepicker 
                            id='datepicker-ending-covid' 
                            :value="interview.DateEndingCovid"
                            :language="datepickerLang"
                            format="dd.MM.yyyy"
                        ></datepicker>
                    </b-form-group>

                    <b-form-group 
                        id='radio-group-had-contact'
                        label="Контактировал с инфекционными больными?"
                        label-for="radio-had-contact"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-had-contact"
                            v-model="interview.hadContact"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-had-contact"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id='radio-group-allergy'
                        label="Аллергические реакции"
                        label-for="radio-allergy"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-allergy"
                            v-model="interview.allergy"
                            :options="allergyOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-allergy"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id='radio-group-reactions'
                        label="Реакции на предыдущие вакцины"
                        label-for="radio-reactions"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-reactions"
                            v-model="interview.reactions"
                            :options="reactionsOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-reactions"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-season-flu"
                        label="Вакцинация от гриппа в текущем сезоне"
                        label-for="radio-season-flu"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-season-flu"
                            v-model="interview.seasonFlu"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-season-flu"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        v-if="interview.seasonFlu === 3"
                        label="Дата вакцинации от гриппа:"
                        label-for="datepicker-flu-vaccin"
                        label-cols-sm="3"
                        label-cols-lg="3"
                    >
                        <datepicker 
                            id='datepicker-flu-vaccin' 
                            :value="interview.DateFluVaccin"
                            :language="datepickerLang"
                            format="dd.MM.yyyy"
                        ></datepicker>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-season-flu"
                        label="Вакцинация против пневмококковой инфекции"
                        label-for="radio-pneumococcus"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-pneumococcus"
                            v-model="interview.pneumococcus"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-pneumococcus"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        v-if="interview.pneumococcus === 3"
                        label="Дата вакцинации от пневмококка:"
                        label-for="datepicker-pneumococcus"
                        label-cols-sm="3"
                        label-cols-lg="3"
                    >
                        <datepicker 
                            id='datepicker-pneumococcus' 
                            :value="interview.DatePneumococcusVaccin"
                            :language="datepickerLang"
                            format="dd.MM.yyyy"
                        ></datepicker>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-chronic-lung"
                        label="Хронические заболевания бронхолёгочной системы"
                        label-for="radio-chronic-lung"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-chronic-lung"
                            v-model="interview.chronicLung"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-chronic-lung"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-chronic-cardio"
                        label="Хронические заболевания сердечно-сосудистой системы"
                        label-for="radio-chronic-cardio"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-chronic-cardio"
                            v-model="interview.chronicCardio"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-chronic-cardio"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-chronic-endocrine"
                        label="Хронические заболевания эндокринной системы"
                        label-for="radio-chronic-endocrine"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-chronic-endocrine"
                            v-model="interview.chronicEndocrine"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-chronic-endocrine"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-oncological"
                        label="Онкологические заболевания"
                        label-for="radio-oncological"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-oncological"
                            v-model="interview.oncological"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-oncological"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-aids"
                        label="Болезнь, вызванная вирусом иммунодефицита человека"
                        label-for="radio-aids"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-aids"
                            v-model="interview.aids"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-aids"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-tuberculosis"
                        label="Туберкулёз"
                        label-for="radio-tuberculosis"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-tuberculosis"
                            v-model="interview.tuberculosis"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-tuberculosis"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-syphilis"
                        label="Сифилис"
                        label-for="radio-syphilis"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-syphilis"
                            v-model="interview.syphilis"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-syphilis"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-hepatitis"
                        label="Гепатит"
                        label-for="radio-hepatitis"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-hepatitis"
                            v-model="interview.hepatitis"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-hepatitis"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-others"
                        label="Иные"
                        label-for="radio-others"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-others"
                            v-model="interview.others"
                            :options="noDataYesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-others"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-covid-reaction"
                        label="ПЦР на коронавирус"
                        label-for="radio-covid-reaction"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-covid-reaction"
                            v-model="interview.covidReaction"
                            :options="covidReactionOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-covid-reaction"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        label="Дата ПЦР на коронавирус:"
                        label-for="datepicker-covid-reaction"
                        label-cols-sm="3"
                        label-cols-lg="3"
                    >
                        <datepicker 
                            id='datepicker-covid-reaction' 
                            :value="interview.DateCovidReaction"
                            :language="datepickerLang"
                            format="dd.MM.yyyy"
                        ></datepicker>
                    </b-form-group>

                    <b-form-group 
                        v-if='sex === "ж"'
                        id="radio-group-pregnancy"
                        label="Вы беременны или планируете забеременеть в ближайшее время?"
                        label-for="radio-pregnancy"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-pregnancy"
                            v-model="interview.pregnancy"
                            :options="yesNoOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-pregnancy"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        v-if='sex === "ж"'
                        id="radio-group-feeding"
                        label="Кормите ли Вы в настоящее время грудью?"
                        label-for="radio-feeding"
                        label-cols-sm="3"
                        label-cols-lg="3"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-feeding"
                            v-model="interview.feeding"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-feeding"
                            required
                        ></b-form-radio-group>
                    </b-form-group>
                </b-form>
            </b-card>
        </b-container>
    </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"

import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale'

export default {
    name: "interview",
    components: { Datepicker },
    data() {
        return {
            datepickerLang: ru,
            answers: [],
            interview: {
                hadCovid: 1,
                DateEndingCovid: new Date(),
                DateCovidReaction: new Date(),
                hadContact: 1,
                allergy: 1,
                reactions: 1,
                seasonFlu: 1,
                DateFluVaccin: new Date(),
                pneumococcus: 1,
                DatePneumococcusVaccin: new Date(),
                chronicLung: 1,
                chronicCardio: 1,
                chronicEndocrine: 1,
                oncological:  1,
                aids: 1,
                tuberculosis: 1,
                syphilis: 1,
                hepatitis: 1,
                others: 1,
                covidReaction: 1,
                pregnancy: "",
                feeding: "",  
            },
            allergyOptions: [
                { text: "Нет данных", value: 1 },
                { text: "Регистрировались", value: 2 },
                { text: "Не регистрировались", value: 3 },
            ],
            reactionsOptions: [
                { text: "Нет данных", value: 1 },
                { text: "Регистрировались", value: 2 },
                { text: "Не регистрировались", value: 3 },
                { text: "Не применимо", value: 4 },
            ],
            covidReactionOptions: [
                { text: "Не знаю результат", value: 1 },
                { text: "Положительный", value: 2 },
                { text: "Отрицательный", value: 3 },
            ],
            yesNoOptions: [
                { text: "Нет", value: 1 },
                { text: "Да", value: 2 },
            ],
            noDataYesNoOptions: [
                { text: "Нет данных", value: 1 },
                { text: "Нет", value: 2 },
                { text: "Да", value: 3 },
            ],
        }
    },
    methods: {
        ...mapActions('interview', ['sendUserAnswers']),


        concatAnswers() {
            let cnt = 20;
            for (let [key, value] of Object.entries(this.interview)) {
                if (typeof value === "number") {
                    let obj = {
                        id_question: cnt + 1,
                        int_answer: value,
                        text_answer: ""
                    }
                    this.answers.push(obj);
                    cnt += 1;
                } else {
                    if (value !== null) {
                        let obj = {
                            id_question: cnt + 1,
                            int_answer: 0,
                            text_answer: value
                        }
                        this.answers.push(obj);
                        cnt += 1;
                    }
                }
            }
            this.sendUserAnswers(this.answers);
        }
    },
    computed: {
        ...mapState({
            sex: state => state.interview.sex
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/interview-components/Interview.vue